import { Common, color } from '@stockbit/ui';
import Image from 'global/Image';
import Link from 'next/link';

const { Flex, Text } = Common;

export const itemList = [
  {
    label: 'Academy',
    icon: 'academy',
    bgColor: 'rgb(239, 247, 252)',
    link: '/academy',
  },
  {
    label: 'Unboxing',
    icon: 'unboxing',
    bgColor: 'rgb(235, 249, 247)',
    link: '/academy/unboxing',
  },
  {
    label: 'Events',
    icon: 'events',
    bgColor: 'rgb(242, 241, 254)',
    link: '/stream/event',
  },
  {
    label: 'Snips',
    icon: 'snips',
    bgColor: 'rgb(242, 246, 232)',
    link: '/stream/snips',
  },
];

function ResearchBox() {
  return (
    <Flex justify="center" padding="20px">
      <Flex
        align="center"
        justify="space-between"
        style={{ width: '100%', maxWidth: '468px' }}
      >
        {itemList.map((item) => (
          <Link href={`${item.link}?source=research`}>
            <a target="_blank" rel="noreferrer noopener" id={item.label}>
              <Flex direction="column" align="center" style={{ gap: 10 }}>
                <Flex
                  align="center"
                  justify="center"
                  style={{
                    width: 60,
                    height: 60,
                    borderRadius: '999px',
                    backgroundColor: item.bgColor,
                  }}
                >
                  <Image
                    src={`/icon/research-stream/header-${item.icon}.svg`}
                  />
                </Flex>
                <Text align="center" color={color.highgray}>
                  {item.label}
                </Text>
              </Flex>
            </a>
          </Link>
        ))}
      </Flex>
    </Flex>
  );
}

export default ResearchBox;
